import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChange } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { Message, MessageType, SeverityType } from '../../message';
import { NotificationsService } from '../../notifications.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'xrm-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnChanges, OnDestroy {
  messagesSub: Subscription;
  messages$: any;
  public messages: Message[];

  @Input() messageType: string;

  @Input() source: string;

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const { messageType: messageType } = changes;
    if (messageType) {
      switch (messageType.currentValue) {
        case 'SystemAlert':
          this.messages$ = this.notificationsService.systemAlerts$;
          break;
        case 'Alert':
          this.messages$ = this.notificationsService.alerts$;
          break;
        default:
          this.messages$ = this.notificationsService.toasts$;
          break;
      }
      this.messagesSub = this.messages$.subscribe(messages => {
        if (this.source) {
          this.messages = messages.filter(msg => msg.source === this.source);
        } else {
          this.messages = messages;
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.messagesSub) {
      this.messagesSub.unsubscribe();
    }
  }

  onCloseMessage(message: Message) {
    this.notificationsService.removeNotification(message);
  }

  severityClass(message) {
    if (message) {
      return Message.severityClass(message);
    }
  }

  constructor(private notificationsService: NotificationsService) {}
}
